import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Spinner, NonIdealState, Button } from '@blueprintjs/core';
import SearchBars from 'components/SearchBars';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';
import QuestionsTable from 'components/Tables/Questions';
import Card from 'components/Card';
import Sticky from 'react-stickynode';
import styled from '@emotion/styled';
import BookingsSidebar from '../bookings/bookings-sidebar';

const CardHolder = styled('div')`
  padding: ${props => `${props.theme.unit*3}px`};
`
const PageWrapGray = styled('div')`
  padding: 12px;
  background-color: #F6F6FA;
  min-height: calc(100vh - 75px);  
`

@inject('store', 'viewStore', 'questionStore') @observer
class QuestionIndexPage extends Component {
  @observable visible = true;

  render() {
    let content;
    let {
      questionStore: {
        questions: {
          isLoading,
          isError
        }
      },store, viewStore
    } = this.props;
    if (isLoading && !isError) {
      content = <CardHolder><div className="spinner-center">
        <Spinner />
        </div>
      </CardHolder>;
    }
    if (isError && !isLoading) {
      content = <div className="no-result-message" >
        <h4>No results</h4>
        <img src="/add-booking.svg" />
        <div className="add-new-record">
          <h5 className="message">No records found.</h5>
          <Button className="bp3-large add-btn bp3-intent-primary" icon={'plus'} small={true} onClick={() => viewStore.questionAdd()}>
            Add Additional Question
          </Button>
        </div>
      </div>;
    }
    if (!isError && !isLoading) {
      content = <QuestionsTable />
    }
    return (
      <div>
        <Helmet>
          <title>Questions | FieldNexus</title>
        </Helmet>
        <div className="row no-gutters">
          <div className="col-lg-2 sidebar-responsive">
              <BookingsSidebar />
          </div>
          <div className="col-lg-10">
            <PageWrapGray>
              <Sticky enabled={true} top={0} innerZ={9}>
                <SearchBars.QuestionSearch />
              </Sticky>
              <Card>
                {content}
              </Card>
            </PageWrapGray>
          </div>
        </div>
      </div>
    )
  }
};

export default QuestionIndexPage;